import { Spinner } from "react-bootstrap";

const Loader = () => {
  return (
    <div
      className="d-flex align-items-center justify-content-center w-100 h-100"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.55)",
        zIndex: 9999,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "12px",
          borderRadius: "4px",
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
        }}
      >
        <Spinner animation="border" role="status" />
      </div>
    </div>
  );
};

export default Loader;
